class LoyaltylionData extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.setProgressBar()
  }

  setProgressBar () {
    const progress = this.els.progress.element
    const points = Number(progress.dataset.currentPoints)
    const pointsNeeded = Number(progress.dataset.neededPoints)
    const totalPoints = points + pointsNeeded

    const progressPercentage = (points / totalPoints) * 100
    this.els['progress-bar'].element.style =
      `--ProgressBar: ${progressPercentage}%`
  }
}

if (!customElements.get('loyaltylion-data')) {
  customElements.define('loyaltylion-data', LoyaltylionData)
}
